'use client'

import React from 'react'
import {ReactNode, useEffect, useState} from 'react'
import classnames from 'classnames'

import styles from './styles.module.css'

export type TIsMenuOpen = boolean | null

export type THeaderBaseRender = (params: {
  isMenuOpen: TIsMenuOpen
  setIsMenuOpen: (isOpen: boolean) => void
}) => ReactNode

type TClassnames = {
  headerCN?: string
  logoCN?: string
  mainCN?: string
  rightCN?: string
  menuCN?: string
  openMenuCN?: string
}

type THeaderBaseProps = {
  logo: THeaderBaseRender
  main?: THeaderBaseRender
  right?: THeaderBaseRender
  menu?: THeaderBaseRender
  getClassnames?: (params: {isMenuOpen: TIsMenuOpen}) => TClassnames
}

export function HeaderBase({logo, main, right, menu, getClassnames}: THeaderBaseProps) {
  const [isMenuOpen, setIsMenuOpen] = useState<TIsMenuOpen>(false)
  const props = {isMenuOpen, setIsMenuOpen}

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto'
  }, [isMenuOpen])

  useEffect(() => {
    const handleEsc = event => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener('keydown', handleEsc)

    return () => {
      document.removeEventListener('keydown', handleEsc)
    }
  }, [])

  let classNames: TClassnames = {}

  if (typeof getClassnames === 'function') {
    classNames = getClassnames({isMenuOpen})
  }

  return (
    <>
      <header className={classnames(styles.header, classNames.headerCN)}>
        <div className={classnames(styles.logo, classNames.logoCN)}>{logo(props)}</div>
        {main && <div className={classnames(styles.main, classNames.mainCN)}>{main(props)}</div>}
        {right && <div className={classnames(styles.right, classNames.rightCN)}>{right(props)}</div>}
      </header>
      <div
        className={classnames(classNames.menuCN, {[classNames.openMenuCN]: isMenuOpen})}
        onClick={() => setIsMenuOpen(false)}
      >
        {menu && menu(props)}
      </div>
    </>
  )
}
